import ListHeroPage from './ListHeroPage';

export default ListHeroPage;
